/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
import { AndroidAppMgrApplicationBasicJson, AndroidAppMgrSKYSEAApplicationJson } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrApplicationSetting'
import { AndroidAppMgrSettingJson } from '@/models/Mobile/AndroidAppDist/AndroidAppMgrSetting'
/**
 * SKYSEAの設定
 */
export class AndroidSkyPolicy {

    // 「制限設定」のチェックボックス状態
    public limitSettingEnabled? :boolean;

    // 「アプリケーション設定」のチェックボックス状態
    public applicationSettingEnabled?: boolean;

    // 「パスワード設定」のチェックボックス状態
    public passwordSettingEnabled?: boolean;

    // 「ネットワーク設定」のチェックボックス状態
    public networkSettingEnabled?: boolean;

    // 「OS設定」のチェックボックス状態
    public osSettingEnabled?: boolean;
    
    // #region ----------- アプリ管理 -----------

    // アプリケーションの基本情報
    public applicationInfo?: AndroidAppMgrApplicationBasicJson[];

    // 設定情報
    public settingInfo?: AndroidAppMgrSettingJson;

    // SKYSEAアプリ情報
    public skyAppInfo?: AndroidAppMgrSKYSEAApplicationJson;

    // SKYSEAバージョン（オンプレの過去管理機考慮の為）
    public version?: number;

    // #endregion ----------- アプリ管理 -----------
}
/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
